/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
export class MyAssertError extends Error {}

const DEBUG = false;

export function myAssert(condition: () => boolean, message: string | undefined = undefined, throwError = true): void {
    if (DEBUG && !condition()) {
        if (throwError) {
            throw new MyAssertError(message);
        } else {
            console.log('NE BI TREBALO OVO OVAKO: ' + message);
        }
    }
}

export function myConsoleLog(message?: any, ...optionalParams: any[]): void {
    if (DEBUG) {
        console.log(message, optionalParams);
    }
}
